export function getI18nConfig(): any {
  return {
    lng: 'en',
    debug: false,
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    },
    resources: {
      en: {
        common: {
          ok: 'OK',
          save: 'Save',
          save_and_take_another_photo: 'Save & Photo',
          delete: 'Delete',
          cancel: 'Cancel',
          clear: 'Clear',
          add: 'Add',
          close: 'Close',
          new_photo_comment: 'Add New Photo Comment',
          signature: 'Signature',
          start_timer: 'Start Timer',
          start_break: 'Start Break',
          stop_break: 'Finish Break',
          stop_timer: 'Stop Timer',
          ticked: 'Ticked',
          not_ticked: 'Not Ticked',
          previous: 'Previous',
          next: 'Next',
          row: 'Row',
          add_row: 'Add Row',
          saving: 'Saving...',
          comment: 'Comment',
          photos: 'Photos',
          media: 'Media',
          video: 'Video',
          attachments: 'Attachments',
          take_a_photo: 'Take a Photo',
          take_a_video: 'Take a Video',
          select_from_gallery: 'Select from Gallery',
          add_signature: 'Add Signature',
          dynamic_datagrid_delete_label: 'Delete',
          dynamic_datagridlist_delete_label: 'Delete List',
          dynamic_datagridlist_add_label: 'Add List',
          annotate: 'Annotate',
          rotate: 'Rotate',
          save_annotation: 'Save Annotation',
          initial_photo_comment: 'Photo Comment',
          initial_video_comment: 'Video Comment',
          select: 'Select',
          search: 'Search',
          photo_comment: 'Photo Comment',
          gallery: 'Group Photos',
          add_gallery_photo: 'Add Group Photo',
          validation_errors: 'Validation Errors',
          please_correct_the_following: 'Please correct the following:',
          customLabel_franchisee: 'Franchisee',
          customLabel_franchisees: 'Franchisees',
          customLabel_site: 'Site',
          customLabel_sites: 'Sites',
          question_help: 'Help',
          question_help_image: 'Help Image',
          question_photo: 'Add Photo',
          question_attachment: 'Upload File',
          question_video: 'Upload Video',
          record_video: 'Record a Video',
          select_video: 'Select Video',
          question_comment: 'Add Comment',
          customLabel_person: 'person',
          customLabel_people: 'people',
          customLabel_personType: 'person Type',
          customLabel_personTypes: 'person Types',
          customLabel_ticket: 'ticket',
          customLabel_tickets: 'tickets',
          customLabel_incident: 'incident',
          customLabel_incidents: 'incidents',
          customLabel_incidentName: 'Name Of Affected Person',
          customLabel_incidentTypeInjury: 'Type of Injury',
          customLabel_incidentCategory: 'incident Category',
          customLabel_incidentCategories: 'incident Categories',
          customLabel_incidentDetailCategoryOtherLabel: 'To Be Determined',
          customLabel_incidentStatusOpen: 'Open',
          customLabel_incidentStatusPending: 'Pending',
          customLabel_incidentStatusResolved: 'Resolved',
          priority_critical: 'Critical',
          priority_high: 'High',
          priority_medium: 'Medium',
          priority_low: 'Low',
          ticket_subject_template: 'Q: {{question}}',
          ticket_content_template:
            'Question: {{question}}\nAnswer: {{answer}}\n$t(customLabel_checklist): {{checklist}}\n$t(customLabel_checklist) Date: {{checklistDate}}'
        }
      }
    }
  }
}
